import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Chip, Button, Typography } from '@material-ui/core';

import KPTable from '../../../../components/KPTComponents/KPTable';
import PopupMenu from '../../../../components/CustomComponents/PopupMenu';
import PreviewModal from '../../../../components/CustomComponents/PreviewModal';
import DuyetThanhTichModal from '../../../../components/CustomComponents/DuyetThanhTichModal';

import BaoCaoUpdate from '../BaoCaoUpdate/BaoCaoUpdate';
import { reportsActions } from '../../../../actions';
import { REPORTS_CONSTANTS } from '../../../../constants';
import { resolveQcvLabel } from '../../../../utils/qcvScoreOptions';


export default function BaoCaoTable(props) {
  const dispatch = useDispatch();
  const scoreInformationList = useSelector(
    (state) => state.scoreInformationReducer.scoreInformationList
  );
  const loading = useSelector(state => state.reportsReducer.loading);
  const totalReportList = useSelector(state => state.reportsReducer.totalReportList);
  const personalReportList = useSelector(state => state.reportsReducer.personalReportList);

  const [values, setValues] = useState(null);
  const [duyetThanhTich, setDuyetThanhTich] = useState(null);

  const [detail, setDetail] = useState(null);
  const [preview, setPreview] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [deleteMenuAnchor, setDeleteMenuAnchor] = useState(false);

  const openDeleteMenu = (e, id) => {
    setDeleteId(id);
    setDeleteMenuAnchor(e.currentTarget);
  }

  const closeDeleteMenu = () => {
    setDeleteId(null);
    setDeleteMenuAnchor(null);
  }

  const handleAccepted = (row = duyetThanhTich) => {
    dispatch(reportsActions.updateReportAccepted(
      [{
        id: row.formScientificReportId,
        accepted: !row.thanhTichAccepted,
        score: values?.score || 0,
        note: values?.note || '',
      }]
    ));
    setDuyetThanhTich(null);
    setValues(null);
  }

  const handleDelete = () => {
    dispatch(reportsActions.deleteReport(deleteId));
    closeDeleteMenu();
  }
  
  const mobileMode = window.innerWidth <= 768;

  var tableRows = [];
  if (props?.rows) {
    tableRows = props?.rows;
  } else {
    tableRows = props.filterType === 'person' ? personalReportList : totalReportList;
  }

  var columns = [
    { title: <b>STT</b>, dataIndex: 'id', width: '5%', render: (_, row, id) => id + 1 },
    {
      title: <b>Tiêu đề báo cáo</b>,
      dataIndex: 'title',
      width: props.type === 'update' ? '25%' : '30%',
      sorter: (a, b) => a.title.localeCompare(b.title),
    },
    {
      title: <b>Tên hội thảo</b>,
      dataIndex: 'conferenceTitle',
      width: '12%',
    },
    {
      title: <b>NXB</b>,
      dataIndex: 'publisher',
      width: '12%',
    },
    {
      title: <b>Danh sách tác giả</b>,
      dataIndex: 'author',
      width: '20%',
    },
    {
      title: <b>Vai trò</b>,
      dataIndex: 'role',
      width: '20%',
      filters: [
        { text: 'Tác giả chính', value: 'main' },
        { text: 'Đồng tác giả', value: 'member' }
      ],
      onFilter: (value, row) => row.role === value,
      render: (value) => value === 'main' ? 'Tác giả chính' : 'Đồng tác giả',
    },
    {
      title: <b>Tình trạng</b>,
      dataIndex: 'thanhTichAccepted',
      width: '15%',
      filters: [
        { text: 'Đã được duyệt', value: true },
        { text: 'Chưa được duyệt', value: false }
      ],
      onFilter: (value, row) => row.thanhTichAccepted === value,
      render: (value) => (
        <Chip
          size='small'
          variant='outlined'
          color={value ? 'primary' : 'default'}
          label={`${value ? 'Đã' : 'Chưa'} duyệt`}
          style={{ width: '100%' }}
        />
      )
    },
    {
      title: <b>Tác vụ</b>,
      dataIndex: 'actions',
      width: '15%',
      render: (_, row) => (
        <>
          <Typography
            variant='body2'
            color='primary'
            className='actions-button'
            onClick={() => setDetail({...row, link: row?.link.includes('/storage/awardRegister/profile') ? undefined : row?.link })}
          >
            Chi tiết
          </Typography>
          {!(props.type === 'accept') && (
            <Typography
              variant='body2'
              color='secondary'
              className='actions-button'
              onClick={(e) => openDeleteMenu(e, row.id)}
            >
              Xoá
            </Typography>
          )}
          {row?.link.includes('doi') && (
            <a target='_blank' rel='noreferrer' href={row.link}>Link DOI</a>
          )}
          {row?.preview.includes('/storage/awardRegister/profile') && (
            <Typography variant='body2' className='actions-button' onClick={() => setPreview(row?.preview)}>Minh chứng</Typography>
          )}
           {(props.type === 'accept') && (
            <Typography
              variant='body2'
              color={row?.thanhTichAccepted ? 'secondary' : 'primary'}
              className='actions-button'
              onClick={() => {
                if (row?.thanhTichAccepted) handleAccepted(row); else setDuyetThanhTich(row);
              }}
            >
              {`${row?.thanhTichAccepted ? 'Huỷ xác' : 'Xác'} nhận`}
            </Typography>
          )}
        </>
      ),
    },
  ];

  if (props.type === 'accept') {
    columns = [
      { ...columns[0] },
      {
        title: <b>Thông tin thành tích</b>,
        dataIndex: 'id',
        width: '50%',
        render: (_, row) => (
          <>
            <Typography variant='body2'><b>Tên bài báo: </b>{row.title}</Typography>
            <Typography variant='body2'><b>Danh sách tác giả: </b>{row.author} {`(${row.numberAuthor})`}</Typography>
            <Typography variant='body2'><b>Nhà xuất bản: </b>{row.publisher}</Typography>
            <Typography variant='body2'><b>Tên hội thảo: </b>{row.conferenceTitle}</Typography>
            <Typography variant='body2'>
              <b>Xếp hạng: </b>
              {resolveQcvLabel(scoreInformationList, '3', REPORTS_CONSTANTS.TYPE_OPTIONS.ALL, row.type)}
            </Typography>
            <Typography variant='body2'>
              <b>Vai trò: </b>
              {row.role === 'main' ? 'Tác giả chính' : 'Đồng tác giả'}
            </Typography>
          </>
        ) 
      },
      { title: <b>Điểm</b>, dataIndex: 'score', width: '5%' },
      { title: <b>Ghi chú</b>, dataIndex: 'note', width: '15%' },
      { ...columns[6], width: '13%' },
      { ...columns[7], width: '12%' },
    ];
  }

  if (props.type === 'update') {
    if (mobileMode) {
      columns = [
        {...columns[1], title: <b>Tiêu đề</b>, width: '35%'},
        {...columns[3], width: '25%'},
        {...columns[5], width: '20%'},
        {...columns[7], width: '20%'},
      ];
    } else {
      columns = [
        {...columns[0], width: '5%'},
        {...columns[1], width: '25%'},
        {...columns[2], width: '15%'},
        {...columns[3], width: '10%'},
        {...columns[4], width: '25%'},
        {...columns[5], width: '10%'},
        {...columns[7], width: '10%'},
      ];
    }
  }

  return (
    <Grid item xs={12}>
      <KPTable
        nonBorder={props.type === 'accept'}
        columns={columns}
        rows={tableRows}
        loading={loading}
      />

      <BaoCaoUpdate detail={detail} acceptMode={props.type === 'accept'} onClose={() => setDetail(null)} />

      <PopupMenu
        position='center'
        anchorEl={deleteMenuAnchor}
        handleClose={closeDeleteMenu}
        render={
          <div style={{ padding: 8 }}>
            <Typography style={{ paddingBottom: 16 }}>Xác nhận xoá báo cáo khoa học?</Typography>
            <Button variant='outlined' style={{ width: 'calc(50% - 4px)',fontSize:'12px' }} onClick={closeDeleteMenu}>Huỷ</Button>
            <Button variant='contained' color='secondary' style={{ marginLeft: 8, width: 'calc(50% - 4px)',fontSize:'12px' }} onClick={handleDelete}>Xác nhận</Button>
          </div>
        }
      />

      <PreviewModal
        open={!!preview}
        url={preview}
        handleClose={() => setPreview(null)}
      />

      <DuyetThanhTichModal
        type='formScientificReport'
        info={duyetThanhTich}
        values={values}
        setValues={setValues}
        open={!!duyetThanhTich}
        handleClose={() => setDuyetThanhTich(null)}
        handleSubmit={handleAccepted}
      />
    </Grid>
  );
}